import { isNullish } from "../type-guards";

const higherIsBetterFields = new Set([
  "xAirRestrictorMax",
  "xFuelRestrictorMax",
  "xRefuelRestrictorMax",
  "pEngineBoost",
  "mFuelMassCapacityMax",
  "mRefuelMassMax",
  "VFuelVolumeCapacityMax",
  "VRefuelVolumeMax",
  "PEngineMax",
  "nEngineMax",
  "vCarMax",
  "rPowerGainAboveRefVelocity",
  "aRakeMax",
  "aWingRmax",
  "aCamberFmax",
  "aCamberRmax",
  "EStintMax",
]);

const lowerIsBetterFields = new Set([
  "rLambdaMin",
  "mCarBallastMin",
  "mCarWeightEmptyMin",
  "mCarWeightTotalMin",
  "hRideFmin",
  "hRideRmin",
  "aRakeMin",
  "aWingRmin",
  "aCamberFmin",
  "aCamberRmin",
  "vPowerCurveBelowRefVelocity",
]);

const neutralFields = new Set(["rPowerCurveReference", "vPowerGainReference", "zWingMin"]);

const red = "#ff0000";
const green = "#008000";
const yellow = "#ffff00";

// Depending on the field and if there has be a change, increase or decrease we want a highlight cell background
export const getCellColorBopTracker = (
  value: number | string | undefined | null,
  baseline: number | string | undefined | null,
  fieldKey: string,
) => {
  if (value === baseline) return undefined;
  if (isNullish(value) && isNullish(baseline)) return undefined;

  if (neutralFields.has(fieldKey)) {
    return yellow;
  }

  // Directional fields need two numbers to know the direction
  if (typeof value !== "number" || typeof baseline !== "number") return undefined;

  if (higherIsBetterFields.has(fieldKey)) {
    return value > baseline ? green : red;
  }
  if (lowerIsBetterFields.has(fieldKey)) {
    return value < baseline ? green : red;
  }

  return undefined;
};
